query IssuesFilterOptions($runId: ConditionID!) {
	filter_groups: issues(run_id_eq: $runId) {
		url_group_uniq_array
		severity_name_group_uniq_array
		type_name_group_uniq_array
	}
	issues(run_id_eq: $runId) {
		conformance
	}
}
